import React from 'react';
import ReactSelect from 'react-select';

export default function SelectField({
    id,
    label,
    options,
    value,
    onChange,
    error,
    disabled = false,
    required = false,
    placeholder = 'Seleccione...',
    isSearchable = false
}) {
    const selectedOption = options.find(opt => opt.value === value) || null;

    const customStyles = {
        // Forzamos el ancho total del contenedor
        container: (provided) => ({
            ...provided,
            width: '100%'
        }),
        // Para que el “control” (el área seleccionable) tenga la misma altura y estilo que .form-control
        control: (provided, state) => ({
            ...provided,
            width: '100%',
            minHeight: 'calc(2.40rem + 3px)',
            height: 'calc(2.25rem + 3px)',
            borderColor: error ? '#dc3545' : provided.borderColor,
            boxShadow: state.isFocused
                ? error
                    ? '0 0 0 .25rem rgba(220,53,69,.25)'
                    : provided.boxShadow
                : provided.boxShadow,
            '&:hover': {
                borderColor: error ? '#dc3545' : provided.borderColor
            }
        }),
        // El menú sigue con z-index alto
        menu: (provided) => ({
            ...provided,
            zIndex: 1000
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#6c757d'
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#000000'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#f8f9fa' : '#fff',
            color: '#212529',
            cursor: 'pointer'
        })
    };

    return (
        <div className="mb-3">
            <label htmlFor={id} className="form-label">
                {label}{required && ' *'}
            </label>
            <ReactSelect
                inputId={id}
                options={options}
                value={selectedOption}
                onChange={opt => onChange(id, opt ? opt.value : '')}
                placeholder={placeholder}
                isDisabled={disabled}
                isSearchable={isSearchable}
                styles={customStyles}
                classNamePrefix="react-select"
            />
            {error && (
                <div className="invalid-feedback d-block">
                    {Array.isArray(error) ? error[0] : error}
                </div>
            )}
        </div>
    );
}
